import { makeObservable, observable, action } from 'mobx';

export type MotivationType =
  | 'healthWellness'
  | 'lookingGreat'
  | 'socialSupport'
  | 'achievementProgress'
  | 'enjoyment';

export type MotivationOptionType = {
  title: string;
  value: MotivationType;
  image: string;
};

export class MotivationStore {
  selectedMotivations: Set<MotivationType> = new Set();

  motivationOptions: MotivationOptionType[] = [
    { title: 'Enjoyment', value: 'enjoyment', image: '🎉' },
    {
      title: 'Achievement and progress',
      value: 'achievementProgress',
      image: '🥇',
    },
    { title: 'Health and wellness', value: 'healthWellness', image: '🧘' },
    { title: 'Social support', value: 'socialSupport', image: '🤝' },
    { title: 'Looking great', value: 'lookingGreat', image: '🔥' },
  ];

  shuffledMotivations = this.shuffleMotivations();

  constructor() {
    makeObservable(this, {
      selectedMotivations: observable,
      toggleMotivation: action,
      motivationOptions: observable,
      shuffleMotivations: action,
    });
  }

  toggleMotivation(inputMotivation: MotivationType) {
    if (this.selectedMotivations.has(inputMotivation)) {
      this.selectedMotivations.delete(inputMotivation);
    } else {
      this.selectedMotivations.add(inputMotivation);
    }
  }

  shuffleMotivations() {
    const newArr = [...this.motivationOptions];
    for (let i = this.motivationOptions.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    this.motivationOptions = [...newArr];
  }
}

export const motivationStore = new MotivationStore();
